import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import {ITimeworkDay} from '@/types/pharmacy';

dayjs.extend(updateLocale)
dayjs.updateLocale('en', {
    months: [
        "Января", "Февраля", "Марта", "Апреля", "Мая", "Июня", "Июля",
        "Августа", "Сентября", "Октября", "Ноября", "Декабря"
    ]
})

/**
 * Форматирует ISO-дату в строку вида "DD MMMM YYYY".
 * @param iso ISO-строка даты.
 */
export const dateFromISO = (iso: string) => {
    return dayjs(iso).format('DD MMMM YYYY')
}

/**
 * Статус работы аптеки.
 */
export enum WorkStatus {
    OPEN = 1,
    COMING_CLOSE = 2,
    CLOSED = 3
}

/**
 * Результат проверки статуса работы аптеки.
 */
export interface IObjectWorkStatus {
    status: WorkStatus;
    closeInfo?: string;
    openInfo?: string;
}

const getBeautyTime = (time: number) => {
    let t = time / 1000;
    if (time > 1000 * 60 * 60 * 24) {
        const days = Math.floor(t / 60 / 60 / 24);
        t = t - days * 60 * 60 * 24;
        const hours = Math.floor(t / 60 / 60);
        t = t - hours * 60 * 60;
        const minutes = Math.floor(t / 60);
        return `${days} д ${hours} ч ${minutes} м`;
    } else if (time > 1000 * 60 * 60) {
        const hours = Math.floor(t / 60 / 60);
        t = t - hours * 60 * 60;
        const minutes = Math.floor(t / 60);
        return `${hours} ч ${minutes} м`;
    }
    const minutes = Math.floor(t / 60);
    return `${minutes} м`;
}

/**
 * Определяет статус работы аптеки по расписанию.
 * @param timework Расписание работы аптеки.
 * @param allDay Признак круглосуточной работы.
 */
export const getTimeworkStatus = (timework: ITimeworkDay[], allDay: boolean): IObjectWorkStatus => {
    const findNextIndex = () => {
        let index = todayIndex === 6 ? 0 : (todayIndex + 1);
        while (daysBetween < 7 && String(timework[index].date_from) === 'null') {
            index = index === 6 ? 0 : (index + 1);
            daysBetween++;
        }
        return index;
    }

    const now = new Date();
    const day = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const nowTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes).getTime();
    const todayIndex = day === 0 ? 6 : (day - 1);
    let daysBetween = 1;
    const nextIndex = findNextIndex();

    const nextDayFromH = !timework[nextIndex].date_from ? 0 : Number(timework[nextIndex].date_from.substr(0, 2));
    const nextDayFromM = !timework[nextIndex].date_from ? 0 : Number(timework[nextIndex].date_from.substr(3, 2));
    const tomorrow = new Date(now.getTime() + (24 * 60 * 60 * 1000 * daysBetween));
    const nextDayFrom = new Date(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate(), nextDayFromH, nextDayFromM).getTime();

    const dateFromH = !timework[todayIndex].date_from ? 0 : Number(timework[todayIndex].date_from.substr(0, 2));
    const dateFromM = !timework[todayIndex].date_from ? 0 : Number(timework[todayIndex].date_from.substr(3, 2));
    const dateFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate(), dateFromH, dateFromM).getTime();

    const dateToH = !timework[todayIndex].date_to ? 0 : Number(timework[todayIndex].date_to.substr(0, 2));
    const dateToM = !timework[todayIndex].date_to ? 0 : Number(timework[todayIndex].date_to.substr(3, 2));
    const dateTo = new Date(now.getFullYear(), now.getMonth(), now.getDate(), dateToH, dateToM).getTime();

    const lunchFromH = !timework[todayIndex].lunch_from ? 0 : Number(timework[todayIndex].lunch_from.substr(0, 2));
    const lunchFromM = !timework[todayIndex].lunch_from ? 0 : Number(timework[todayIndex].lunch_from.substr(3, 2));
    const lunchFrom = lunchFromH === 0 ? 0 : new Date(now.getFullYear(), now.getMonth(), now.getDate(), lunchFromH, lunchFromM).getTime();

    const lunchToH = !timework[todayIndex].lunch_to ? 0 : Number(timework[todayIndex].lunch_to.substr(0, 2));
    const lunchToM = !timework[todayIndex].lunch_to ? 0 : Number(timework[todayIndex].lunch_to.substr(3, 2));
    const lunchTo = new Date(now.getFullYear(), now.getMonth(), now.getDate(), lunchToH, lunchToM).getTime();

    let openinigTime = '';
    let closingTime = '';

    const isClosed = () => {
        if (nowTime >= dateFrom && nowTime < dateTo && (lunchFrom === 0 || nowTime < lunchFrom && nowTime >= lunchTo)) return false;
        else if (nowTime >= dateFrom && nowTime < dateTo && lunchFrom != 0 && nowTime >= lunchFrom && nowTime < lunchTo) {
            openinigTime = `${getBeautyTime(lunchTo - nowTime)}`;
            return true;
        } else if (nowTime < dateFrom) {
            openinigTime = `${getBeautyTime(dateFrom - nowTime)}`;
            return true;
        } else if (nowTime >= dateTo) {
            openinigTime = `${getBeautyTime(nextDayFrom - nowTime)}`;
            return true;
        }
    }

    const isComingClosed = () => {
        if ((dateTo - nowTime) > 1000 * 60 * 60 && (lunchFrom === 0 || (lunchFrom - nowTime) > 1000 * 60 * 60)) return false;
        else if ((dateTo - nowTime) > 1000 * 60 * 60 && lunchFrom != 0) {
            closingTime = `${getBeautyTime(lunchFrom - nowTime)}`;
            openinigTime = `${getBeautyTime(lunchTo - nowTime)}`;
            return true;
        } else if ((dateTo - nowTime) <= 1000 * 60 * 60) {
            closingTime = `${getBeautyTime(dateTo - nowTime)}`;
            openinigTime = `${getBeautyTime(nextDayFrom - nowTime)}`;
            return true;
        }
    }

    if (allDay) {
        return {
            status: WorkStatus.OPEN,
            openInfo: 'Круглосуточно'
        }
    } else {
        if (isClosed()) {
            return {
                status: WorkStatus.CLOSED,
                closeInfo: 'Аптека сейчас закрыта',
                openInfo: `Откроется через ${openinigTime}`
            };
        } else {
            if (isComingClosed()) {
                return {
                    status: WorkStatus.COMING_CLOSE,
                    closeInfo: `Аптека закроется через ${closingTime}`,
                    openInfo: `Откроется через ${openinigTime}`
                };
            } else {
                return {
                    status: WorkStatus.OPEN,
                    openInfo: `Сегодня открыто до ${timework[todayIndex].date_to.slice(0, 5)}`
                }
            }
        }
    }
}

/**
 * Возвращает количество дней до указанной даты.
 * @param dateTo Целевая дата.
 */
export function getDiffDays(dateTo) {
    const now = new Date();
    const diff = +dateTo - +now;
    return diff / (1000 * 60 * 60 * 24);
}

/**
 * Преобразует строку срока годности в объект Date.
 * @param expirity_date Строка вида YYYYMMDD.
 */
export function normalizeExpiryDate(expirity_date) {
    return new Date(+expirity_date.substring(0, 4), +expirity_date.substring(4, 6) - 1, +expirity_date.substring(6, 8));
}

/**
 * Возвращает true, если срок годности препарата менее 91 дня.
 * @param expirity_date Строка вида YYYYMMDD.
 */
export function isBadExpiryDate(expirity_date) {
    const normalizedExpirityDate = normalizeExpiryDate(expirity_date);
    return (getDiffDays(normalizedExpirityDate) < 91);
}

/**
 * Форматирует дату в строку DD.MM.YY.
 * @param date Объект даты.
 */
export function formatDate(date: Date): string {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    return `${dd}.${mm}.${yy}`;
}